export default "__VITE_ASSET__CKzP2LUE__"